import { render, staticRenderFns } from "./GitlabPublishModal.vue?vue&type=template&id=470125a0&"
import script from "./GitlabPublishModal.vue?vue&type=script&lang=js&"
export * from "./GitlabPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabPublishModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GitlabPublishModal.vue
// module id = 1686
// module chunks = 1